// Object.filter = (obj, predicate) =>
//     Object.keys(obj)
//         .filter(key => predicate(obj[key]))
//         .reduce((res, key) => (res[key] = obj[key], res), {});

export const toTitleCase = function (string) {
    return `${string[0].toUpperCase()}${string.substr(1)}`
}

export const numberWithCommas = function (value) {
    return value.toString().replace('$', '')
        .replace(',', '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const metaLookup = {
    category: 'categories',
    interface: 'interfaces',
    platform: 'platforms',
    language: 'languages',
    framework: 'frameworks'
}

export const metaReverseLookup = {
    categories: 'category',
    interfaces: 'interface',
    platforms: 'platform',
    languages: 'language',
    frameworks: 'framework'
}

export const clearFormFields = formFieldInputs => {
    Object.keys(formFieldInputs).forEach(key => {
        formFieldInputs[key].clear()
    })
}
